module.exports = __webpack_public_path__ + "assets/ic_cart_plus-b9ff2d.svg";